import React, {useEffect, useState} from 'react';
import Footer from '../components/Footer';
import { Link } from "react-router-dom";
import HeaderNew from '../components/HeaderNew';
import HomeImage from "../assets/images/deck1.jpg";
import resourcesServices from '../services/resourcesServices';
import { Helmet } from 'react-helmet-async';
import { errorMessage } from '../errorHandler';

const Sorteos = () => {
  const [sorteos, setSorteos] = useState([]);

  useEffect(() => {
    Sorteos()
  }, []);


  const Sorteos = async () => {
    try {
      const data = await resourcesServices.obtenerResources('sorteos/publicos');
      setSorteos(data.data);

    } catch (error) {
      errorMessage(error)
    }
  };

  return (
    <div className="container p-0 bg-main text-center">
      <Helmet>
        <title>Sorteos</title>
        <meta name="description" content='Mirá los sorteos y sus ganadores' />
        <link rel="canonical" href={`https://bailongo.club/sorteos`} />
      </Helmet>
      <HeaderNew />
      {
        sorteos.length > 0 ? (
          <div className="container-fluid">
            <div className='p-5'>
              {
                sorteos.map((sorteo, idx) => (
                  <div key={idx} className='text-start mb-5'>
                    <div className="alert alert-success" role="alert">
                      <h5>{sorteo.nombre} <span className="badge text-bg-dark">fecha y horario del sorteo {sorteo.f_fin_formateado}hs</span></h5>
                    </div>
                    <h5>Últimos números del teléfono de los participantes</h5>
                    <div className='row'>
                      {
                        sorteo.participante_sorteos.map((participante, idx) => (
                          participante.estado === 'ganador' && (
                            <div className='col-sm-2 border p-1'><h6 className='mb-0'>{participante.ultimos_numeros_telefono} <span className="badge text-bg-success">Ganador</span></h6></div>
                          )
                        ))
                      }
                      {
                        sorteo.participante_sorteos.map((participante, idx) => (
                          participante.estado === 'perdedor' && (
                            <div className='col-sm-2 border p-1'><h6 className='mb-0'>{participante.ultimos_numeros_telefono}</h6></div>
                          )
                        ))
                      }
                    </div>

                  </div>
                ))
              }
            </div>
          </div>

        ) : (
          <h3>Sin sorteos para mostrar</h3>
        )
      }
      <Footer />
    </div>
  );
};

export default Sorteos;